import { constants } from "@common/_constants";
import { ErrorService } from "@common/_services";
import { refetch } from "@common/_services/refetch";

export const FriendService = {
    search,
};

function search(options, abortSignal: AbortSignal) {
    //const url = Routing.Api.Pro.Friends.SEARCH;
    const url = constants.Routing.Api.Pro.Friends.SEARCH;

    const settings = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(options),
        signal: abortSignal,
    };
    return refetch(url, settings).then(unwrapResult);
}

function unwrapResult(response) {
    return ErrorService.handleErrors(response)
        .then(resp => resp.json())
        .then(json => json.result);
}
